/*eslint-disable*/
import React, { useEffect, useState, useRef } from 'react';
import { createPortal } from 'react-dom';
import ReactModal from 'react-modal';
import closeSvg from 'src/assets/close.svg';
import { useTranslation } from 'react-i18next';
import { useLocalStorage } from 'src/hooks/useLocalStorage';
import { DatePicker, RegularButton, HorizonDropdown, ICommonDropdownOption, CommonInput } from 'pg-ui-library';
import { useTypedSelector } from '../../../hooks/useTypedSelector';
// import { ICompany } from '../../../interfaces';
import { DateTime } from 'luxon';

import InvoiceService from 'src/services/invoice.service';
import {
  CloseIcon,
  Content,
  ContentContainer,
  FormTitle,
  Header,
  BottomContainer,
  Field,
  SectionTitle,
  FullRow,
  SearchDropdown,
  LoadingText,
  SearchItem,
  DropdownWrapper,
} from './filtersStyle';
interface NewFiltersReviewModalProps {
  isOpen: boolean;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
  updateFilters: (
    startDate: Date | null,
    endDate: Date | null,
    selectedCompany: any,
    status: string,
    employmentType: string,
    showInvocieId: string,
    assignmentId: string,
    employmentStatus: string,
    clientName: string,
    hireType: string,
    employeeName: string,
    dateCriteria: string,
    dateRangeType: string
  ) => void;
  statusOptions: ICommonDropdownOption[];
}

export const ExpenseFilter: React.FC<NewFiltersReviewModalProps> = ({
  isOpen,
  setIsOpen,
  updateFilters,
  statusOptions,
}) => {
  const { t } = useTranslation();
  const statusContainerRef = useRef<HTMLDivElement>(null);
  const hireTypeContainerRef = useRef<HTMLDivElement>(null);

  const [userRole] = useLocalStorage('userRole', null);
  const [showFun, setShowFun] = useState(true);

  useEffect(() => {
    if (userRole === 'external_manager') {
      setShowFun(true);
    } else {
      setShowFun(false);
    }
  }, [userRole]);

  // --- Filter States ---
  const [dateRangeType, setDateRangeType] = useState<string>(''); // Before | After | Between | Exactly
  const [startDate, setStartDate] = useState<Date | null>(null);
  const [endDate, setEndDate] = useState<Date | null>(null);

  // const [status, setStatus] = useState<string>('');
  // const [hireType, setHireType] = useState<string>('');

  const [selectedStatuses, setSelectedStatuses] = useState<string[]>([]);
  const [selectedHireTypes, setSelectedHireTypes] = useState<string[]>([]);

  const [isStatusFocused, setIsStatusFocused] = useState(false);
  const [isHireTypeFocused, setIsHireTypeFocused] = useState(false);

  const [employmentType, setEmploymentType] = useState<string>('');
  const [expenseShowId, setexpenseShowId] = useState<string>('');
  const [assignmentId, setAssignmentId] = useState<string>('');

  const [employmentStatus, setEmploymentStatus] = useState<string>('');
  const [selectedCompany, setSelectedCompany] = useState<string>('');
  const [employeeName, setEmployeeName] = useState<string>('');
  const [clientName, setClientName] = useState<string>('');

  const { data } = useTypedSelector(state => state.companies);
  const { config } = useTypedSelector(state => state.config.data);

  const [clientOptions, setClientOptions] = useState<ICommonDropdownOption[]>([]);
  const [clientSearchValue, setClientSearchValue] = useState<string>('');
  const [isClientLoading, setIsClientLoading] = useState<boolean>(false);
  const [isClientFocused, setIsClientFocused] = useState(false);

  const [dropdownOptionsCompany, setDropdownOptionsCompany] = useState<ICommonDropdownOption[]>([]);

  const [dateCriteria, setDateCriteria] = useState<string>('period');

  const [dropdownOptionsDateField, setDropdownOptionsDateField] = useState<ICommonDropdownOption[]>([
    { key: '', label: 'Select Date Type', value: '' },
    { key: 'period', label: 'Expense Period', value: 'period' },
    { key: 'submittedDate', label: 'Submitted Date', value: 'submittedDate' },
    { key: 'approvedDate', label: 'Approved Date', value: 'approvedDate' },
    { key: 'billedDate', label: 'Billed Date', value: 'billedDate' },
    { key: 'payrolledDate', label: 'Payrolled Date', value: 'payrolledDate' },
  ]);

  const [dropdownOptionsStatus, setDropdownOptionsStatus] = useState<ICommonDropdownOption[]>([
    { key: 'approved', label: 'Approved', value: 'approved' },
    { key: 'payProcessed', label: 'Pay Processed', value: 'pay_processed' },
    { key: '', label: 'All', value: '' },
  ]);

  const [dropdownOptionsHireType, setDropdownOptionsHireType] = useState<ICommonDropdownOption[]>([
    { key: 'W2', label: 'W2', value: 'W2' },
    { key: 'C2C', label: 'C2C', value: 'C2C' },
    { key: '1099', label: '1099', value: '1099' },
    { key: 'Payroll', label: 'Payroll', value: 'Payroll' },
    { key: 'IndependentContractor', label: 'Independent Contractor', value: 'IC' },
  ]);

  const [dropdownOptionsDateRange, setDropdownOptionsDateRange] = useState<ICommonDropdownOption[]>([
    { key: 'select', label: 'Select Range', value: '' },
    { key: 'before', label: 'Before', value: 'before' },
    { key: 'after', label: 'After', value: 'after' },
    { key: 'between', label: 'Between', value: 'between' },
    { key: 'exactly', label: 'Exactly', value: 'exactly' },
  ]);

  // --- Initialize company dropdown ---

  useEffect(() => {
    if (!isOpen) return;

    const fetchInitialClients = async () => {
      try {
        setIsClientLoading(true);

        const response = await InvoiceService.searchClients({
          clientSearch: '', // now backend supports empty
          limit: 20,
        });

        const formatted = response.map((client: any) => ({
          key: client.clientId,
          label: client.clientName,
          value: client.clientName,
        }));

        setClientOptions(formatted);
      } catch (err) {
        console.error(err);
      } finally {
        setIsClientLoading(false);
      }
    };

    fetchInitialClients();
  }, [isOpen]);

  useEffect(() => {
    if (!clientSearchValue) return;

    const delayDebounce = setTimeout(async () => {
      try {
        setIsClientLoading(true);

        const response = await InvoiceService.searchClients({
          clientSearch: clientSearchValue,
          limit: 20,
        });

        const formatted = response.map((client: any) => ({
          key: client.clientId,
          label: client.clientName,
          value: client.clientName,
        }));

        setClientOptions(formatted);
      } catch (error) {
        console.error(error);
      } finally {
        setIsClientLoading(false);
      }
    }, 400);

    return () => clearTimeout(delayDebounce);
  }, [clientSearchValue]);

  const filterApply = () => {
    updateFilters(
      startDate,
      endDate,
      selectedCompany,
      // status,
      selectedStatuses.join(','),
      employmentType,
      expenseShowId,
      assignmentId,
      employmentStatus,
      clientName,
      // hireType,
      selectedHireTypes.join(','),
      employeeName,
      dateCriteria,
      dateRangeType
    );
    setIsOpen(false);
  };

  const clearApply = () => {
    setDateRangeType('');
    setStartDate(null);
    setEndDate(null);
    // setStatus('');
    setSelectedStatuses([]);
    setSelectedHireTypes([]);
    setEmploymentType('');
    setexpenseShowId('');
    setEmploymentStatus('');
    setSelectedCompany('');
    setEmployeeName('');
    setClientName('');
    updateFilters(null, null, '', '', '', '', '', '', '', '', '', '', '');
    setIsOpen(false);

    setClientName('');
    setClientSearchValue('');
    setClientOptions([]);
  };

  const handleDateChange = (date: Date | null, setter: Function) => setter(date);
  const handleModalClose = () => setIsOpen(false);

  const isStartDateEnabled = ['before', 'after', 'between', 'exactly'].includes(dateRangeType);
  const isEndDateEnabled = dateRangeType === 'between';

  useEffect(() => {
    if (!isStatusFocused) return;

    const handleClickOutside = (event: MouseEvent) => {
      const target = event.target as Node;

      const container = statusContainerRef.current;
      const dropdown = document.getElementById('status-dropdown');

      if (container?.contains(target) || dropdown?.contains(target)) {
        return;
      }

      setIsStatusFocused(false);
    };

    document.addEventListener('mousedown', handleClickOutside);

    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [isStatusFocused]);

  useEffect(() => {
    if (!isHireTypeFocused) return;

    const handleClickOutside = (event: MouseEvent) => {
      const target = event.target as Node;

      const container = hireTypeContainerRef.current;
      const dropdown = document.getElementById('hiretype-dropdown');

      if (container?.contains(target) || dropdown?.contains(target)) {
        return;
      }

      setIsHireTypeFocused(false);
    };

    document.addEventListener('mousedown', handleClickOutside);

    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [isHireTypeFocused]);

  const toggleStatusSelection = (value: string) => {
    setSelectedStatuses(prev => (prev.includes(value) ? prev.filter(v => v !== value) : [...prev, value]));
  };

  const toggleHireTypeSelection = (value: string) => {
    setSelectedHireTypes(prev => (prev.includes(value) ? prev.filter(v => v !== value) : [...prev, value]));
  };

  return (
    <ReactModal
      isOpen={isOpen}
      onRequestClose={handleModalClose}
      ariaHideApp={false}
      style={{
        overlay: { margin: 'auto', backgroundColor: 'rgba(0, 0, 0, 0.6)' },
        content: {
          borderRadius: '30px',
          backgroundColor: '#F3F4F8',
          margin: 'auto',
          width: '80%',
          maxWidth: '1300px',
          height: '500px',
          // display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          padding: '20px',
          gap: '20px',
        },
      }}
    >
      <Header>
        <FormTitle>{t('employeeReviewChanges.newFilters')}</FormTitle>
        <CloseIcon src={closeSvg} onClick={handleModalClose} />
      </Header>

      <ContentContainer>
        <Content>
          {showFun && (
            <Field>
              <label>Assignment Id</label>
              <CommonInput
                label=""
                placeholder="Enter Assignment Id"
                value={assignmentId}
                onChange={e => setAssignmentId(e.target.value)}
              />
            </Field>
          )}

          {showFun && (
            <Field>
              <label>Worker Name</label>
              <CommonInput
                label=""
                placeholder="Enter worker name"
                value={employeeName}
                onChange={e => setEmployeeName(e.target.value)}
              />
            </Field>
          )}

          {showFun && (
            <Field>
              <label>Hire Type</label>
              <DropdownWrapper ref={hireTypeContainerRef}>
                <CommonInput
                  label=""
                  placeholder="Select Hire Type"
                  value={selectedHireTypes.join(', ')}
                  onFocus={() => setIsHireTypeFocused(true)}
                  readOnly
                />

                {isHireTypeFocused &&
                  createPortal(
                    <SearchDropdown
                      id="hiretype-dropdown"
                      style={{
                        position: 'fixed',
                        top: hireTypeContainerRef.current?.getBoundingClientRect().bottom ?? 0,
                        left: hireTypeContainerRef.current?.getBoundingClientRect().left ?? 0,
                        width: hireTypeContainerRef.current?.offsetWidth ?? 250,
                      }}
                    >
                      {dropdownOptionsHireType.map(option => (
                        <SearchItem
                          key={option.key}
                          onMouseDown={e => {
                            e.preventDefault();
                            toggleHireTypeSelection(option.value);
                          }}
                        >
                          <input
                            type="checkbox"
                            checked={selectedHireTypes.includes(option.value)}
                            readOnly
                            style={{ marginRight: 8 }}
                          />
                          {option.label}
                        </SearchItem>
                      ))}
                    </SearchDropdown>,
                    document.body
                  )}
              </DropdownWrapper>
            </Field>
          )}

          {/* Row 2 */}
          <Field>
            <label>Status</label>
            <DropdownWrapper>
              <div ref={statusContainerRef}>
                <CommonInput
                  label=""
                  placeholder="Select Status"
                  value={selectedStatuses.join(', ')}
                  onFocus={() => setIsStatusFocused(true)}
                  readOnly
                />
              </div>

              {isStatusFocused &&
                createPortal(
                  <SearchDropdown
                    id="status-dropdown"
                    style={{
                      position: 'fixed',
                      top: statusContainerRef.current?.getBoundingClientRect().bottom ?? 0,
                      left: statusContainerRef.current?.getBoundingClientRect().left ?? 0,
                      width: statusContainerRef.current?.offsetWidth ?? 250,
                    }}
                  >
                    {statusOptions.map(option => (
                      <SearchItem
                        key={option.key}
                        onMouseDown={e => {
                          e.preventDefault();
                          toggleStatusSelection(option.value);
                        }}
                      >
                        <input
                          type="checkbox"
                          checked={selectedStatuses.includes(option.value)}
                          readOnly
                          style={{ marginRight: 8 }}
                        />
                        {option.label}
                      </SearchItem>
                    ))}
                  </SearchDropdown>,
                  document.body
                )}
            </DropdownWrapper>
          </Field>

          <Field>
            <label>Expense ID</label>
            <CommonInput
              label=""
              placeholder="Enter Expense ID"
              value={expenseShowId}
              onChange={e => setexpenseShowId(e.target.value)}
            />
          </Field>

          {/* Date Range Section */}
          <SectionTitle>Date Range</SectionTitle>

          {/* <FullRow>
            <Field>
              <label>Date Filter Type</label>
              <HorizonDropdown
                label=""
                setValue={setDateRangeType}
                value={dateRangeType}
                placeholder="Select Date Range"
                options={dropdownOptionsDateRange}
              />
            </Field>

            <Field>
              <label>Start Date</label>
              <DatePicker
                id="startDate"
                name="startDate"
                label=""
                selected={startDate}
                onChange={date => handleDateChange(date, setStartDate)}
                disabled={!isStartDateEnabled}
                dateFormat="MM/dd/yyyy"
              />
            </Field>

            <Field>
              <label>End Date</label>
              <DatePicker
                id="endDate"
                name="endDate"
                label=""
                selected={endDate}
                onChange={date => handleDateChange(date, setEndDate)}
                disabled={!isEndDateEnabled}
                dateFormat="MM/dd/yyyy"
              />
            </Field>
          </FullRow> */}

          <FullRow>
            <Field>
              <label>Date Type</label>
              <DropdownWrapper>
                <HorizonDropdown
                  label=""
                  setValue={setDateCriteria}
                  value={dateCriteria}
                  placeholder="Select Date Type"
                  options={dropdownOptionsDateField}
                />
              </DropdownWrapper>
            </Field>

            <Field>
              <label>Date Filter Type</label>
              <DropdownWrapper>
                <HorizonDropdown
                  label=""
                  setValue={setDateRangeType}
                  value={dateRangeType}
                  placeholder="Select Date Range"
                  options={dropdownOptionsDateRange}
                />
              </DropdownWrapper>
            </Field>

            <Field>
              <label>Start Date</label>
              <DatePicker
                id="startDate"
                name="startDate"
                label=""
                selected={startDate}
                onChange={date => handleDateChange(date, setStartDate)}
                disabled={!isStartDateEnabled}
                dateFormat="MM/dd/yyyy"
              />
            </Field>

            <Field>
              <label>End Date</label>
              <DatePicker
                id="endDate"
                name="endDate"
                label=""
                selected={endDate}
                onChange={date => handleDateChange(date, setEndDate)}
                disabled={!isEndDateEnabled}
                dateFormat="MM/dd/yyyy"
              />
            </Field>
          </FullRow>
        </Content>

        <BottomContainer>
          <RegularButton onClick={filterApply}>{t('global.button.search')}</RegularButton>
          <RegularButton onClick={clearApply}>{t('global.button.clear')}</RegularButton>
        </BottomContainer>
      </ContentContainer>
    </ReactModal>
  );
};
